import React, { memo, useEffect, useState } from 'react'
import { useParams, NavLink } from "react-router-dom"
import axios from 'axios'
const Sjfb = memo((props) => {
  const [contentArr, setContentArr] = useState({
    code: 0
  })
  const [addContent, setAddContent] = useState({})
  const [xjContent, setXjcontent] = useState("")
  const [gctimgs,setGctimgs] = useState([])
  const contentid = useParams();
  const _axioxurl = 'http://common.scimall.org/api.php/demo/whzwz2021/detail?termId=' + contentid.id
  useEffect(() => {
    axios(_axioxurl)
      .then((res) => {
        setContentArr(res.data.data)
      })
    axios('http://tp5.scimall.org/portal/clicks/index?h5Name=whzwz2021').then((res) => {
      console.log(res)
    })
    if (parseInt(contentid.id) === 27) {
      axios("http://common.scimall.org/api.php/demo/whzwz2021/detail?termId=42")
        .then((res) => {
          setAddContent(res.data.data.post_content)
        })
    }
    if (parseInt(contentid.id) === 40) {
      axios("http://common.scimall.org/api.php/demo/whzwz2021/detail?termId=44")
        .then((res) => {
          setXjcontent(res.data.data.post_content)
        })
    }
    if (parseInt(contentid.id) === 28) {
      axios("http://common.scimall.org/api.php/demo/whzwz2021/detail?termId=45")
        .then((res) => {
          setGctimgs(res.data.data.imgs)
        })
    }
  }, [])
  const cline = (content) => {
    const arr = content.split('==')
    return (
      <>
        {
          arr.map((item, index) => {
            return (
              <span key={index}>{item.trim()}</span>
            )
          })
        }
      </>
    )
  }
  return (
    <div className='contentwarp'>
      {
        contentArr.post_title &&
        <div className='contentTop'>
          <div className="banner">
            <img src={contentArr.banner} alt="" />
            <NavLink className="gohome" to='/'>
              <svg t="1621560571353" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2402" width="64" height="64"><path d="M562.9 80.9C535.4 56 493.5 56 466 80.9L74 453.1c-14.7 13.5-15.7 36.4-2.2 51.1 13.3 14.5 35.8 15.7 50.6 2.6l6.2-5.9v388.4c0 39.9 32.3 72.4 72.2 72.4h210.5V744c0-28.1 22.7-50.9 50.8-51h99.1c28.1 0 50.9 22.8 50.9 50.9V961.7h215.4c39.9 0 72.3-32.4 72.3-72.3V505.7c16.1 14.5 38.9 13.4 52.2-1.5 13.4-14.8 12.2-37.7-2.6-51.1L562.9 80.9z" p-id="2403" fill="#ffffff"></path></svg>
            </NavLink>
          </div>
          <div className="content">
            {
              contentArr.post_content &&
              <>
                <div className='ctitile'>活动介绍</div>
                <p className='desc' dangerouslySetInnerHTML={{ __html: contentArr.post_content }}>
                  {/* {cline(contentArr.post_content)} */}
                </p>
              </>
            }
            {
              contentArr.post_excerpt &&
              <>
                <div className='ctitile'>活动时间</div>
                <p className='time'>
                  {cline(contentArr.post_excerpt)}
                </p>
              </>
            }
            {
              parseInt(contentid.id) === 40 &&
              <>
                <div className='ctitile'>活动安排</div>
                <p className='deschtml' dangerouslySetInnerHTML={{ __html: xjContent }}>
                  {/* {cline(contentArr.post_content)} */}
                </p>
              </>
            }
            {
              contentArr.address &&
              <>
                <div className='ctitile'>活动地点</div>
                <p className='time'>
                  {contentArr.address}
                </p>
              </>
            }
            {
              contentArr.theme &&
              <>
                <div className='ctitile'>活动主题</div>
                <p className='time'>
                  {contentArr.theme}
                </p>
              </>
            }
            {
              contentArr.hd_xc &&
              <>
                <div className='ctitile'>活动宣传</div>
                <p className='time'>
                  {contentArr.hd_xc}
                </p>
              </>
            }
            {
              (contentArr.imgs.length !== 0 && contentArr.video.length === 0) &&
              <>
                <div className='ctitile'>{(parseInt(contentid.id) === 32 || parseInt(contentid.id) === 28) ? "精彩内容" : "精彩瞬间"}</div>
                <div className="imgWrap">
                  {
                    contentArr.imgs.map((item, index) => {
                      return (
                        <img src={item} alt="" key={index} />
                      )
                    })
                  }
                </div>
              </>
            }
            {
              (contentArr.imgs.length !== 0 && parseInt(contentid.id) === 28) &&
              <>
                <div className='ctitile'>{(parseInt(contentid.id) === 32 || parseInt(contentid.id) === 28) ? "精彩内容" : "精彩瞬间"}</div>
                <div className="imgWrap">
                  {
                    contentArr.imgs.map((item, index) => {
                      return (
                        <img src={item} alt="" key={index} />
                      )
                    })
                  }
                </div>
              </>
            }
            {
              parseInt(contentid.id) === 27 &&
              <>
                <div className='ctitile'>大使风采</div>
                <p className='deschtml' dangerouslySetInnerHTML={{ __html: addContent }}>
                  {/* {cline(contentArr.post_content)} */}
                </p>
              </>
            }
            {/* {
              parseInt(contentid.id) === 38 &&
              <>
                <div className='ctitile'>精彩视频</div>
                <video src="./img/demo.mp4" className='video' controls='controls' poster={contentArr.thumbnail}></video>
              </>
            } */}
            {
              (contentArr.video.length !== 0 && parseInt(contentid.id) !== 28) &&
              <>
                <div className='ctitile'>精彩视频</div>
                <div className="videoWrap">
                  {
                    contentArr.video.map((item, index) => {
                      return (
                        <video src={item} key={index} className='video' controls='controls' poster={contentArr.imgs[index]}></video>
                      )
                    })
                  }
                </div>
              </>
            }
            {
              (contentArr.video.length !== 0 && parseInt(contentid.id) === 28) &&
              <>
                <div className='ctitile'>精彩视频</div>
                <div className="videoWrap">
                  {
                    contentArr.video.map((item, index) => {
                      return (
                        <video src={item} key={index} className='video' controls='controls' poster={gctimgs[index]}></video>
                      )
                    })
                  }
                </div>
              </>
            }
          </div>
        </div>
      }
      <div className="footer">
        <NavLink className='footertab' to='/lxwm'>
          联系我们
              </NavLink>
        <NavLink className='footertab' to='/zzdw'>
          组织单位
              </NavLink>
      </div>
    </div>
  )
})
export default Sjfb